document.addEventListener("DOMContentLoaded", function () {
  if (typeof SwatchesConstructor !== "undefined") {
    SwatchesConstructor.prototype.createOptionsView = function (t, e, a, n) {
      // Retrieve product data
      var productData = this.getJsonObject();
      console.log('productData', productData);

      // Validate product data
      if (!productData || !productData.options || !productData.variants) {
        console.error("Product data, options, or variants are missing!");
        return;
      }

      var options = productData.options; // Option groups (e.g., Size, Color)
      var variants = productData.variants; // All variants of the product

      // Build HTML for swatches
      var swatchesHtml = '';
      options.forEach(function (option, index) {
        swatchesHtml += `<div class="tt-title-option">${option.name}</div>`;
        swatchesHtml += `<ul class="custom-swatches" data-option-index="${index}">`;

        option.values.forEach(function (value) {
          // Check if this option value is available in any variant
          var isAvailable = variants.some(function (variant) {
            return (
              variant.available &&
              (variant.option1 === value || variant.option2 === value || variant.option3 === value)
            );
          });

          swatchesHtml += `
            <li class="custom-swatch ${isAvailable ? '' : 'disabled'}" 
                data-option-value="${value}">
              ${value}
            </li>`;
        });

        swatchesHtml += '</ul>';
      });

      // Note: Hidden input for variant ID is already in the form with class "input_variant"
      // No need to add it here, but we'll ensure it's updated

      // Update the swatches container
      var container = document.querySelector(t);
      if (!container) {
        console.error(`Swatches container not found for selector: ${t}`);
        return;
      }
      container.innerHTML = swatchesHtml;

      // Attach event listeners to swatches
      var swatches = container.querySelectorAll(".custom-swatch");
      var inputHidden = document.querySelector(".input_variant");

      if (!inputHidden) {
        console.error("Variant input with class 'input_variant' not found!");
        return;
      }

      // Store selected options
      var selectedOptions = new Array(options.length).fill(null);

      swatches.forEach(function (swatch) {
        swatch.addEventListener("click", function () {
          // Check if the swatch is disabled
          if (swatch.classList.contains("disabled")) {
            console.warn(`Option "${swatch.getAttribute('data-option-value')}" is unavailable and cannot be selected.`);
            return;
          }

          // Get the option index from the parent ul
          var optionIndex = this.parentElement.getAttribute('data-option-index');
          // Remove 'active' class from all swatches in the same option group
          var siblingSwatches = this.parentElement.querySelectorAll('.custom-swatch');
          siblingSwatches.forEach((el) => el.classList.remove("active"));

          // Add 'active' class to the clicked swatch
          this.classList.add("active");

          // Update selected options
          selectedOptions[optionIndex] = this.getAttribute("data-option-value");

          // Find the matching variant
          var selectedVariant = variants.find(function (variant) {
            return (
              variant.available &&
              (!options[0] || variant.option1 === selectedOptions[0]) &&
              (!options[1] || variant.option2 === selectedOptions[1]) &&
              (!options[2] || variant.option3 === selectedOptions[2])
            );
          });

          // Update the hidden input with the selected variant ID
          if (selectedVariant) {
            inputHidden.value = selectedVariant.id;
            console.log('Selected Variant ID:', selectedVariant.id);
          } else {
            console.warn('No available variant found for selected options:', selectedOptions);
            inputHidden.value = variants[0].id; // Fallback to first variant ID
            // Optionally, show an error message to the user
          }
        });
      });

      // Initialize with the first available variant
      var firstAvailableVariant = variants.find(function (variant) {
        return variant.available;
      }) || variants[0];
      inputHidden.value = firstAvailableVariant.id;

      // Preselect swatches for the first available variant
      options.forEach(function (option, index) {
        var value = firstAvailableVariant[`option${index + 1}`];
        if (value) {
          var swatch = container.querySelector(`.custom-swatch[data-option-value="${value}"]`);
          if (swatch && !swatch.classList.contains('disabled')) {
            swatch.classList.add('active');
            selectedOptions[index] = value;
          }
        }
      });
    };
  } else {
    console.warn("SwatchesConstructor is not defined.");
  }
});